import React from "react";
import styles from "./Policy.module.css";

export const Policy = () => {
  return (
    <div className={styles.container}>
      <h1 className={styles.title}>Terms of Service / Privacy Policy</h1>
      <p className={styles.subText}>Last Updated: December 28th, 2024</p>
      <h1 className={styles.title}>
        1. Emergency Situations and Crisis Disclaimer
      </h1>
      <p className={styles.subText}>
        IF YOU ARE EXPERIENCING THOUGHTS OF SUICIDE, SELF-HARM, OR HARMING
        OTHERS, OR IF YOU ARE EXPERIENCING A MENTAL HEALTH EMERGENCY:
      </p>
      <ul className={styles.subText}>
        <li>IMMEDIATELY STOP USING JUSTTALK</li>
        <li>DIAL 988 (US) FOR THE SUICIDE AND CRISIS LIFELINE</li>
        <li>CALL YOUR LOCAL EMERGENCY SERVICES (911 IN US)</li>
        <li>GO TO THE NEAREST EMERGENCY ROOM</li>
        <li>CONTACT A QUALIFIED MENTAL HEALTH PROFESSIONAL</li>
      </ul>
      <p className={styles.subText}>
        JUSTTALK IS NOT AN EMERGENCY SERVICE AND CANNOT HELP IN CRISIS
        SITUATIONS.
      </p>
      <h1 className={styles.title}>2. Introduction</h1>
      <p className={styles.subText}>
        Welcome to JustTalk, an AI-powered mental health application. By
        accessing or using our app, you agree to these Terms of Service
        ("Terms"). If you disagree with any part of these Terms, please do not
        use our services.
      </p>
      <h1 className={styles.title}>3. Eligibility and Age Restrictions</h1>
      <p className={styles.subText}>
        You must be at least 18 years old to use JustTalk. If you are between 13
        and 18 years old, you may only use JustTalk with the consent and
        supervision of a parent or legal guardian.
      </p>
      <h1 className={styles.title}>4. User Data</h1>
      <p className={styles.subText}>
        JustTalk anonymizes all user data. This means that if a user switches
        devices, user data will not be saved. JustTalk may collect analytics and
        usage data if the user opts in. We do not share your personal data with
        third parties other than for analytics purposes, except as required by
        law.
      </p>
      <h1 className={styles.title}>5. Subscriptions and Payment</h1>
      <p className={styles.subText}>
        JustTalk offers a subscription service. By subscribing, you agree to pay
        the subscription fee. You may cancel your subscription at any time.
      </p>
      <h1 className={styles.title}>6. AI Therapy and Liability Disclaimer</h1>
      <p className={styles.subText}>
        JustTalk provides general mental health advice through AI technology.
        However:
      </p>
      <ul className={styles.subText}>
        <li>JustTalk is not a licensed therapist or mental health provider.</li>
        <li>
          The AI is not a substitute for professional medical advice, diagnosis,
          or treatment.
        </li>
        <li>
          JustTalk does not guarantee the accuracy, completeness, or
          appropriateness of the AI's advice.
        </li>
        <li>
          You acknowledge that JustTalk is not responsible for any consequences,
          harm, or losses resulting from using the AI's advice.
        </li>
        <li>
          JustTalk is not suitable for emergency situations or crisis
          intervention.
        </li>
        <li>
          If you are experiencing a mental health emergency, please contact your
          local emergency services immediately or use a crisis helpline.
        </li>
      </ul>
      <h1 className={styles.title}>7. Intellectual Property</h1>
      <p className={styles.subText}>
        JustTalk retains all rights to the app's content, features, and
        functionality. Users retain ownership of any original content they input
        during interactions, granting JustTalk a non-exclusive license to use
        this content for service improvement.
      </p>
      <h1 className={styles.title}>8. Prohibited Uses</h1>
      <p className={styles.subText}>You agree not to:</p>
      <ul className={styles.subText}>
        <li>Use the app for any illegal purpose</li>
        <li>Attempt to gain unauthorized access to any part of the app</li>
        <li>Use the app to harass, abuse, or harm others</li>
        <li>Impersonate any person or entity</li>
        <li>Interfere with or disrupt the app's functionality</li>
      </ul>
      <h1 className={styles.title}>9. Termination</h1>
      <p className={styles.subText}>
        JustTalk reserves the right to suspend or terminate your account for
        violations of these Terms or for any other reason at our discretion.
      </p>
      <h1 className={styles.title}>10. Modifications to Terms</h1>
      <p className={styles.subText}>
        We may modify these Terms at any time. Continued use of the app after
        changes constitutes acceptance of the new terms.
      </p>
      <h1 className={styles.title}>11. Limitations of AI</h1>
      <p className={styles.subText}>
        While our AI strives to provide helpful advice, it has limitations in
        understanding complex human emotions and situations. It should not be
        considered a replacement for human judgment or professional mental
        health care.
      </p>
      <h1 className={styles.title}>12. Contact Information</h1>
      <p className={styles.subText}>
        If you have any questions about these Terms, please contact us at:
      </p>
      <address className={styles.subText}>
        BRIAN MASON
        <br />
        BOX 95215
        <br />
        DURHAM NC 27708-5215
        <br />
        team@originapps.dev
      </address>
    </div>
  );
};
